import { render } from "./SZargur.vue?vue&type=template&id=79c6279d&scoped=true"
import script from "./SZargur.vue?vue&type=script&lang=js"
export * from "./SZargur.vue?vue&type=script&lang=js"

import "./SZargur.vue?vue&type=style&index=0&id=79c6279d&lang=scss&scoped=true"
import "./SZargur.vue?vue&type=style&index=1&id=79c6279d&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c6279d"]])

export default __exports__